import React from "react";
import { Link } from "react-router-dom";

const metrics = [
  { value: "38%", label: "Faster collections" },
  { value: "Automated", label: "Reminder workflows" },
  { value: "QBO Sync", label: "Ledger connected" },
  { value: "4.9", label: "Customer rating" },
];

export const BrandPanel = () => (
  <aside className="login-brand">
    <svg
      className="login-brand__decor login-brand__decor--top"
      width="400"
      height="400"
      viewBox="0 0 400 400"
      fill="none"
      aria-hidden="true"
    >
      <circle cx="320" cy="80" r="180" stroke="#fff" strokeWidth="1" />
      <circle cx="320" cy="80" r="120" stroke="#fff" strokeWidth="1" />
      <circle cx="320" cy="80" r="60" stroke="#fff" strokeWidth="1" />
    </svg>
    <svg
      className="login-brand__decor login-brand__decor--bottom"
      width="320"
      height="320"
      viewBox="0 0 320 320"
      fill="none"
      aria-hidden="true"
    >
      <circle cx="80" cy="240" r="140" stroke="#fff" strokeWidth="1" />
      <circle cx="80" cy="240" r="90" stroke="#fff" strokeWidth="1" />
    </svg>

    <div className="login-brand__inner">
      <div className="login-brand__hero">
        <div className="login-brand__pill">
          QuickBooks Online integrated
        </div>
        <h1>Take the headaches out of collecting A/R.</h1>
        <p>
          Automated reminders, smart workflows, and real-time aging synced live
          with your QuickBooks ledger.
        </p>
        <div className="login-brand__metrics">
          {metrics.map((metric) => (
            <div className="login-brand__metric" key={metric.label}>
              <strong>{metric.value}</strong>
              <span>{metric.label}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="login-brand__footer">
        © {new Date().getFullYear()} Quattro Software ·{" "}
        <Link to="/terms">Terms</Link> · <Link to="/privacy">Privacy</Link>
      </div>
    </div>
  </aside>
);
